import { cn } from '@/shared/lib';

/**
 * Знак Console1LogoMark дизайн-системы VinoWay (figma node 1:16881, 3 варианта).
 * Квадрат цвета wine-bordeaux со скруглением и буквой «V» шрифтом Prata.
 */
const LOGO_MARK_SIZES = {
  24: { box: 'size-24 rounded-7', letter: 'text-[14px]' },
  32: { box: 'size-32 rounded-9', letter: 'text-[19px]' },
  40: { box: 'size-40 rounded-11', letter: 'text-[24px]' },
} as const;

export type LogoMarkSize = keyof typeof LOGO_MARK_SIZES;

/** Буква знака дизайн-системы (props.text1 ?? "V" в Console1LogoMark) — графический знак, не текст. */
const LOGO_MARK_LETTER = 'V';

export interface LogoMarkProps {
  size?: LogoMarkSize;
  className?: string;
  /**
   * Загруженный «Логотип платформы» (`/admin/config` → `brand.logo_url`): показывается вместо знака
   * дизайн-системы в том же квадрате (белая подложка, логотип целиком).
   */
  src?: string | null;
}

export function LogoMark({ size = 32, className, src }: LogoMarkProps) {
  const variant = LOGO_MARK_SIZES[size];
  if (src) {
    return (
      <span
        aria-hidden="true"
        className={cn(
          'relative inline-flex shrink-0 items-center justify-center overflow-hidden bg-paper-pure shadow-[inset_0_0_0_1px_var(--vw-line-hair)]',
          variant.box,
          className,
        )}
      >
        <img src={src} alt="" className="size-full object-contain p-2" />
      </span>
    );
  }
  return (
    <span
      aria-hidden="true"
      className={cn(
        'relative inline-flex shrink-0 items-center justify-center bg-wine-bordeaux',
        variant.box,
        className,
      )}
    >
      <span
        className={cn(
          'font-logomark leading-none font-normal whitespace-nowrap text-ink-inverse-pure',
          variant.letter,
        )}
      >
        {LOGO_MARK_LETTER}
      </span>
    </span>
  );
}
